// ─── Public Routes ────────────────────────────────────────────
export const ROUTES = {
  HOME:       "/",
  PRODUCTS:   "/products",
  PRODUCT:    (slug: string) => `/products/${slug}`,
  PRODUCT_BY_VARIANT: (variantId: number) => `/products/variant/${variantId}`,
  CATEGORIES: "/categories",
  CATEGORY:   (slug: string) => `/categories/${slug}`,
  CART:       "/cart",
  CONTACT:    "/contact",

  // Auth
  LOGIN:      "/login",
  LOGOUT:     "/logout",

  // Protected
  CHECKOUT:   "/checkout",
  ORDERS:     "/orders",
  ORDER:      (id: number) => `/orders/${id}`,
  WISHLIST:   "/wishlist",
  PROFILE:    "/profile",
  SETTINGS:   "/profile/settings",
} as const;
